import React from 'react';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import { WhatsApp, Call, SupportAgent } from '@mui/icons-material';
import { keyframes } from '@emotion/react';

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
`;

const WhatsAppSupport = () => {
  const phoneNumber = '+255738867270';
  const defaultMessage = 'Hello BeyondSchools';

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`, '_blank');
  };

  const handleCall = () => {
    window.open(`tel:${phoneNumber}`);
  };

  const actions = [
    { icon: <WhatsApp sx={{ color: '#25D366' }} />, name: 'WhatsApp', onClick: handleWhatsApp },
    { icon: <Call sx={{ color: '#128C7E' }} />, name: '+255738867270', onClick: handleCall },
  ];

  return (
    <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 999 }}>
      <SpeedDial
        ariaLabel="Support SpeedDial"
        icon={
          <SpeedDialIcon
            icon={<SupportAgent />}
            sx={{ color: 'white' }}
          />
        }
        FabProps={{
          sx: {
            bgcolor: '#25D366',
            animation: `${bounce} 2s infinite`,
            '&:hover': {
              bgcolor: '#128C7E',
              animation: 'none', // Stop bouncing on hover if preferred
            },
          },
        }}
        direction="up"
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.onClick}
            tooltipOpen
            FabProps={{
              sx: {
                bgcolor: 'white',
                '&:hover': {
                  bgcolor: '#f0f0f0ff',
                },
              },
            }}
          />
        ))}
      </SpeedDial>
    </div>
  );
};

export default WhatsAppSupport;
